import React, { useState, useEffect ,useRef} from "react";
import "../SmcLife/IndexLife.css";
import Male from "../SmcLife/Images/male-icon2.svg";
import Female from "../SmcLife/Images/female-icon2.svg";
import HdfcLogo from "../SmcLife/Images/hdfc.png";
import MaskedInput from "react-text-mask";
import Select from 'react-select'
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import {
    CommaSeprator,
    convertIntoLakh,
    pinRepeatedPattern,
} from "./UtilityComponents/UtilityFunction";
import { FilterData } from "./UtilityComponents/FilterData"
import { useFormik } from "formik";
import { proposlSchema } from "../schemas";
import { CopyToClipboard } from 'react-copy-to-clipboard';


const initialValues = {
    fullName: "",
    panNo: "",
    pin: "",
    occupation: "",
    education: "",
    maritalStatus: "",
    nomineeName: "",
    nomineeRelation: "",
    nomineeAge: "",
    address: "",
    city: '',
    companyId:''
};


const educationOpt = [
    // { value: "disabled", label: "Select your education" },
    { value: "4~Graduate", label: "Graduate" },
    { value: "14~Diploma", label: "Diploma" },
    { value: "5~Post Graduate", label: "Post Graduate & Above" },
    { value: "2~10th", label: "10th/Matriculation" },
    { value: "3~12th", label: "12th/Intermediate" },
    { value: "1~Below SSC", label: "Below SSC" },
    { value: "15~Vocational/ITI", label: "Vocational/ITI" },
    { value: "7~Illiterate", label: "Illitrate" }
]



const SmcLifeProposal = (props) => {
    //console.log("Props:", props)
    const [showDetails, setShowDetails] = useState({});
    const [coverTillAge, setCoverTillAge] = useState("");
    const [OcDataProp, setOcDataProp] = useState("");
    const [payFreq, setPayFreq] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [IsFromHouseWifeComponent, setIsFromHouseWifeComponent] = useState(false);
    const [MaritalList, setMaritalList] = useState([]);
    const [OccupationList, setOccupationList] = useState([]);
    const [EducationList, setEducationList] = useState([]);
    const [NomineeRelation, setNomineeRelation] = useState([]);
    const [QuoteRequest, setQuoteRequest] = useState({});
    const [submitBtn, setSubmitBtn] = useState('Continue');
    const [copyText, setCopyText] = useState(false);

    const occupationRef = useRef(null);
    const educationRef = useRef(null);
    const maritalRef = useRef(null);
    const nomineeRef = useRef(null);

    useEffect(() => {
        const storedProposal = sessionStorage.getItem("proposal");
        if (storedProposal) {
            const parsedProposal = JSON.parse(storedProposal);
            initialValues.fullName = parsedProposal.fullName || "";
            initialValues.panNo = parsedProposal.panNo || "";
            initialValues.pin = parsedProposal.pin || "";
            initialValues.occupation = parsedProposal.companyId === showDetails.CompanyId ? parsedProposal.occupation : "";
            initialValues.education = parsedProposal.companyId === showDetails.CompanyId ? parsedProposal.education : "";
            initialValues.maritalStatus = parsedProposal.companyId === showDetails.CompanyId ? parsedProposal.maritalStatus : "";
            initialValues.nomineeRelation = parsedProposal.companyId === showDetails.CompanyId ? parsedProposal.nomineeRelation : "";
            initialValues.nomineeName = parsedProposal.nomineeName || "";
            initialValues.nomineeAge =  parsedProposal.nomineeAge || "";
            initialValues.address = parsedProposal.address || "";

            if (initialValues.pin) {
                fetchCityState(initialValues.pin);
            }

        }

    }, [showDetails]);

    const history = useHistory();

    const { values, touched, errors,setErrors, handleBlur, handleChange, handleSubmit, isValid, isSubmitting, setSubmitting, setFieldValue } =
        useFormik({
            initialValues: initialValues,
            validationSchema:proposlSchema(city),
            validateOnMount: true,

            onSubmit: (values, action) => {
                getProposal(values);
                //action.resetForm();
                setSubmitting(false);
            },

        });




    useEffect(() => {

        if (IsFromHouseWifeComponent) {
            //setFieldValue('occupation', "4~Housewife");
            setFieldValue('maritalStatus', "M");
        }

    }, [IsFromHouseWifeComponent, setFieldValue])

    useEffect(() => {
        setQuoteRequest(history?.location?.state?.QuoteRequest)
        //console.log(history?.location?.state?.QuoteRequest, "Data");
    }, []);


    useEffect(() => {
        setShowDetails(history?.location?.state?.quote);
        setCoverTillAge(history?.location?.state?.data);
        setOcDataProp(history?.location?.state?.OccData);

        //console.log(history?.location?.state?.OccData, "OCC Data");

        setIsFromHouseWifeComponent(history?.location?.state?.IsFromHouseWifeComponent ?? false)
        /* console.log(IsFromHouseWifeComponent, "IsFromHouseWifeComponent");*/
        initialValues.insurerAge = showDetails.InsurerAge;
        initialValues.companyId = showDetails.CompanyId;
        if (showDetails.PremiumFrequency === "Y") {
            setPayFreq("Yearly");
        } else if (showDetails.PremiumFrequency === "M") {
            setPayFreq("Monthly");
        } else if (showDetails.PremiumFrequency === "H") {
            setPayFreq("Half-Yearly");
        } else if (showDetails.PremiumFrequency === "Q") {
            setPayFreq("Quarterly");
        }
        else if (showDetails.PremiumFrequency === "S") {
            setPayFreq("Single");
        } else {
            console.error("Error in getting premium frequency");
        }

        if (showDetails && MaritalList.length === 0 && showDetails.InsurerId)
            callMasterAPI();
       // console.log(showDetails);

    }, [showDetails]);

    const getProposal = (values) => {
        setSubmitBtn('Wait...');
        setFieldValue('companyId', showDetails.CompanyId);
        sessionStorage.setItem("proposal", JSON.stringify(values));
        const body = {
            InsurerId: showDetails.InsurerId,
            EnquiryNo: showDetails.EnquiryNo,
            FullName: values.fullName,
            PanNo: values.panNo,
            Email: showDetails.Email,
            MobileNo: showDetails.MobileNo,
            Gender: showDetails.Gender,
            EducationID: values.education,
            MaritalStatus: values.maritalStatus,
            OccupationID: values.occupation,
            QuoteTransKey: showDetails.TransKey,
            isAutoPay: showDetails?.IsAutoPay,
            NomineeDetails: {
                Name: values.nomineeName,
                Age: Number(values.nomineeAge),
                RelationID: values.nomineeRelation,
            },
            AddressDetails: {
                CityID: city,
                StateID: state,
                PinCode: values.pin,
                Address: values.address,

            },
        };

        const model = {
            URL: "GetProposal",
            PostString: JSON.stringify(body),
        };

        axios
            .post("central/centralcall/CallReqWithHeader", model)
            .then((res) => {
                if (res.data.StatusCode === 200) {
                    window.location.href = res.data.Data.RedirectUrl;
                    setSubmitBtn('Continue');
                } else {
                    setSubmitBtn('Continue');
                }
            })
            .catch((err) => {
                console.log({ err });
                setSubmitBtn('Continue');
            });

    };

    const fetchCityState = (pin, CompanyId = 0) => {
        const body = {
            "pincode": pin,
            "CompanyId": CompanyId

        };

        const model = {
            URL: "GetCityStateByPin",
            PostString: JSON.stringify(body)
        }
        axios.post("central/centralcall/CallReqWithHeader", model)
            .then((res) => {
                if (res.data.StatusCode === 200) {
                    //const { city, state } = res.data.Data;
                    setCity(res.data.Data[0].CityName);
                    setFieldValue('city', res.data.Data[0].CityName);
                    setState(res.data.Data[0].State_Name);
                } else {
                    setErrors({ ...errors, pin: "Please Enter valid PIN code" });
                }

            })
            .catch((err) => {
            });
    };

    const onPinCodeChange = (e) => {
        let value = e.target.value
        if (value.length === 6 && !pinRepeatedPattern.test(value)) {
            fetchCityState(value);
        } else {
            setCity("");
            setState("");
            setErrors({ ...errors, pin: "Enter valid PIN code" });
        }

    }



    const callMasterAPI = async () => {
        const masterKey = ["OCCUPATION", "QUALIFICATION", "NOMINEERELATION", "MARITAL"];
        //{ InsurerId: showDetails.InsurerId, MasterType: r }
        
        const data = await Promise.all(masterKey.map(r => axios.post(`central/centralcall/CallReqWithHeader`, { URL: "GetMaster", PostString: JSON.stringify({ InsurerId: showDetails.InsurerId, MasterType: r, SomId: r = parseInt(QuoteRequest?.Occupation)})})));
        for (let i = 0; i < masterKey.length; i++) {
            switch (masterKey[i]) {
                case "OCCUPATION":
                    setOccupationList(data[i].data.Data);
                    break;
                case "QUALIFICATION":
                    setEducationList(data[i].data.Data);
                    break;
                case "NOMINEERELATION":
                    setNomineeRelation(data[i].data.Data);
                    break;
                case "MARITAL":
                    setMaritalList(data[i].data.Data);
                    break;
                default:
                    break;
            }

        }
    }

    const handleCopy = () => {
        setCopyText(true);
        setTimeout(() => setCopyText(false), 2000);
    };

    useEffect(() => {
        if (values.panNo.length === 10 && !values.occupation) {
            occupationRef.current.autoOpenDropdown()
        }
        if (values.nomineeAge && !values.nomineeRelation) {
            nomineeRef.current.autoOpenDropdown();
        }
    }, [values.panNo, values.occupation, values.nomineeAge, values.nomineeRelation]);

    return (
        <>
            <div className="SmcLifeProposalMain">
                <div className="space">
                    <div className="LifeProposalBox pb-5">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="ReverseBTNRow">
                                        <a className="arw-right" onClick={() => history.goBack()}>
                                            <i className="fas fa-long-arrow-alt-left"></i>
                                            <span className="mx-2">Back to Quotation</span>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-9">
                                    <div className="SmcQuoteDetail QuoteDetailRowLife mb-4">
                                        <div className="SmcProposalpolicy">
                                            <div className="row">
                                                <div className="col-md-4 PropDetailBorder">
                                                    <div>
                                                        <span className="ProposalDetail_CUST proposal_detail_first_label">
                                                            Your Details
                                                        </span>
                                                        <p>
                                                            <span>
                                                                {showDetails.Gender === "M" ? <img src={Male} className="Cust_Detail_Abt" /> :
                                                                    <img src={Female} className="Cust_Detail_Abt" />}
                                                            </span>
                                                            <span>{showDetails.InsurerAge} years, </span>
                                                            <span>
                                                                {showDetails.Gender === "M" ? "Male" : "Female"}
                                                                ,{" "}
                                                            </span>
                                                            <span>
                                                                {showDetails.IsSmoker === false
                                                                    ? "Non-smoker"
                                                                    : "Smoker"}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="TopRightDetail">
                                                        <div>
                                                            <span className="ProposalDetail_CUST">
                                                                Coverage Amount
                                                            </span>
                                                            <p>
                                                                <strong>
                                                                    ₹{convertIntoLakh(showDetails.SumInsured)}
                                                                </strong>
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <span className="ProposalDetail_CUST">
                                                                Cover till Age
                                                            </span>
                                                            <p>
                                                                <strong>{coverTillAge} years</strong>
                                                            </p>
                                                            {/* <div className="shade-life shade-life2">till 2047</div> */}
                                                        </div>
                                                        <div>
                                                            <span className="ProposalDetail_CUST">
                                                                Payment Frequency
                                                            </span>
                                                            <p>
                                                                <strong>{payFreq}</strong>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="LifeProSideCard life_side_card1 mb-4 HiddenDsktpEnquiry">
                                        <div className="LifeProSideCard1">
                                            <div className="insurer_logo" >
                                                <img src={showDetails?.LogoUrl} className="PerpoRHdfcLogo" />
                                            </div>
                                            <p className="LifeImgHead">
                                                <strong>{showDetails?.PlanName}</strong>
                                            </p>
                                        </div>
                                        <div className="LifeProEnquiryCard2">
                                            <p className="Cust_Enquiry_Smc">Enquiry#</p>
                                            <CopyToClipboard text={showDetails?.EnquiryNo} onCopy={handleCopy}>
                                            <span className="Cust_Enquiry_Smc">
                                                {showDetails?.EnquiryNo}
                                                 <i className="far fa-copy ms-1"></i>
                                            </span>
                                            </CopyToClipboard>
                                            {copyText && <div className="copied_Box">Copied!</div>}
                                        </div>
                                        <div className="LifeProSideCard1">
                                            <div>
                                                <p className="mb-0 ProposalDetail_CUST">Premium</p>
                                                <p className="mb-0 ProposalDetail_CUST">+ GST (18%)</p>
                                            </div>
                                            <div>
                                                <p className="mb-0 Life_Cust_premium">
                                                    ₹{CommaSeprator(showDetails?.NetPremium)}
                                                </p>
                                                <p className="mb-0 Life_Cust_premium">
                                                    ₹{CommaSeprator(showDetails?.GST)}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="LifeProSideCard3">
                                            <span className="Cust-total-Amt mb-2">
                                                Total Premium ({payFreq})
                                            </span>
                                            <span className="Cust-total-Amt mb-2">
                                                <strong>
                                                    ₹{CommaSeprator(showDetails?.TotalPremium)}
                                                </strong>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="ProposalBoxRight LifeProUpdForm">
                                        <form action="">
                                            <div className="ProposalFormContent">
                                                <h1 className="FormContentHead">Few More Details</h1>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="user-input-wrp proposal-user-input">
                                                        <MaskedInput
                                                            className="inputText"
                                                            mask={[
                                                                /[a-zA-Z]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                            ]}
                                                            guide={false}
                                                            required
                                                            showMask={false}
                                                            name="fullName"
                                                            onKeyDown={(e) => {
                                                                // Prevent typing multiple consecutive spaces
                                                                const { value, selectionStart } = e.target;
                                                                if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            value={values.fullName}
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                        />
                                                        {errors.fullName && touched.fullName ? (
                                                            <span className="errors-msg">
                                                                {errors.fullName}
                                                            </span>
                                                        ) : null}
                                                        <span className="floating-label">Full Name</span>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <div className="user-input-wrp proposal-user-input">
                                                        <MaskedInput
                                                            className="inputText User_PAN"
                                                            mask={[
                                                                /[a-zA-Z]/,
                                                                /[a-zA-Z]/,
                                                                /[a-zA-Z]/,
                                                                /[pP]/,
                                                                /[a-zA-Z]/,
                                                                /[0-9]/,
                                                                /[0-9]/,
                                                                /[0-9]/,
                                                                /[0-9]/,
                                                                /[a-zA-Z]/,
                                                            ]}
                                                            guide={false}
                                                            showMask={false}
                                                            maxLength="10"
                                                            minLength="1"
                                                            toUpperCase
                                                            required
                                                            name="panNo"
                                                            value={values.panNo}
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                        />
                                                        {errors.panNo && touched.panNo ? (
                                                            <span className="errors-msg">{errors.panNo}</span>
                                                        ) : null}
                                                        <span className="floating-label">PAN Number</span>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <div className="user-input-wrp">
                                                        <span className={`DropDown_label ${IsFromHouseWifeComponent ? 'DropDown_label_disabled' : ''}`}>Select Your Occupation</span>

                                                        <FilterData
                                                            ArrayList={showDetails.Gender === "M" ? OccupationList?.filter(r => !r.Name.toLowerCase().match("housewife")) : OccupationList}
                                                            FilterKey={"CODE"}
                                                            onSelect={(data) => { setFieldValue('occupation', data.CODE); if (!values.education) educationRef.current.autoOpenDropdown() }}
                                                            DefaultTitle={initialValues.occupation ? OccupationList?.find(option => option.CODE === initialValues.occupation)?.Name : "Select Your Occupation"}
                                                            ListNameKey={"Name"}
                                                            className="filter_dropdwon"
                                                            formIkId="occupation"
                                                            formIkError={errors}
                                                            formIkToched={touched}
                                                            formIkBlurHandler={handleBlur}
                                                            ref={occupationRef}
                                                        />


                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <div className="user-input-wrp">
                                                        <span className="DropDown_label">Select Your Education</span>
                                                        <FilterData
                                                            ArrayList={EducationList}
                                                            FilterKey={"CODE"}
                                                            onSelect={(data) => { setFieldValue('education', data.CODE); if (!values.maritalStatus) maritalRef.current.autoOpenDropdown() }}
                                                            DefaultTitle={initialValues.education ? EducationList.find(option => option.CODE === initialValues.education)?.Name : "Select Your Education"}
                                                            ListNameKey={"Name"}
                                                            className="filter_dropdwon"
                                                            formIkId="education"
                                                            formIkError={errors}
                                                            formIkToched={touched}
                                                            formIkBlurHandler={handleBlur}
                                                            ref={educationRef}
                                                        />
                                                        {/*{errors.education && touched.education ? (
                                                            <span className="errors-msg">
                                                                {errors.education.toString()}
                                                            </span>
                                                        ) : null}*/}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <div className="user-input-wrp">
                                                        <span className={`DropDown_label ${IsFromHouseWifeComponent ? 'DropDown_label_disabled' : ''}`}>Select Marital Status</span>
                                                        <FilterData
                                                            ArrayList={MaritalList}
                                                            FilterKey={"CODE"}
                                                            onSelect={(data) => { setFieldValue('maritalStatus', data.CODE); }}
                                                            DefaultTitle={initialValues.maritalStatus ? MaritalList.find(option => option.CODE === initialValues.maritalStatus)?.Name : "Select Marital Status"}
                                                            ListNameKey={"Name"}
                                                            className="filter_dropdwon"
                                                            formIkId="maritalStatus"
                                                            formIkError={errors}
                                                            formIkToched={touched}
                                                            formIkBlurHandler={handleBlur}
                                                            ref={maritalRef }
                                                        />

                                                        {/*{errors.maritalStatus && touched.maritalStatus && (
                                                            <span className="errors-msg">
                                                                {errors.maritalStatus.toString()}
                                                            </span>
                                                        )}*/}

                                                    </div>
                                                </div>



                                                <div className="col-sm-12">
                                                    <div className="user-input-wrp proposal-user-input">
                                                        <input
                                                            name="address"
                                                            value={values.address}
                                                            onBlur={handleBlur}
                                                            //onChange={handleChange}
                                                            maxLength={150}
                                                            className="inputText"
                                                            onKeyDown={(e) => {
                                                                // Prevent typing multiple consecutive spaces
                                                                const { value, selectionStart } = e.target;
                                                                if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            required
                                                            onChange={(e) => {
                                                                // Prevent leading whitespace
                                                                const value = e.target.value;
                                                                if (value.startsWith(" ")) {
                                                                    setFieldValue('address', value.trimStart());
                                                                } else {
                                                                    setFieldValue('address', value);
                                                                }
                                                            }}
                                                        />
                                                        {errors.address && touched.address ? (
                                                            <span className="errors-msg">{errors.address}</span>
                                                        ) : null}
                                                        <span className="floating-label">Address</span>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="user-input-wrp proposal-user-input">
                                                        <MaskedInput
                                                            mask={[
                                                                /[1-9]/,
                                                                /[0-9]/,
                                                                /[0-9]/,
                                                                /[0-9]/,
                                                                /[0-9]/,
                                                                /[0-9]/,
                                                            ]}
                                                            guide={false}
                                                            required
                                                            showMask={false}
                                                            type="text"
                                                            className="inputText"
                                                            maxLength="6"
                                                            name="pin"
                                                            value={values.pin}
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                onPinCodeChange(e)
                                                                handleChange(e)
                                                            }
                                                            }
                                                        />
                                                        {errors.pin && touched.pin ? (
                                                            <span className="errors-msg">{errors.pin}</span>
                                                        ) : null}
                                                        <span className="floating-label">PIN Code</span>
                                                        {(city && state && !errors.pin) && <p>
                                                            <span className="city_state">{city}, {state}</span>
                                                        </p>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="ProposalFormContent">
                                                    <h1 className="FormContentHead">Nominee Details</h1>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="user-input-wrp proposal-user-input">
                                                        <MaskedInput
                                                            className="inputText"
                                                            mask={[
                                                                /[a-zA-Z]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                                /[a-zA-Z\s]/,
                                                            ]}
                                                            guide={false}
                                                            required
                                                            showMask={false}
                                                            onKeyDown={(e) => {
                                                                // Prevent typing multiple consecutive spaces
                                                                const { value, selectionStart } = e.target;
                                                                if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            name="nomineeName"
                                                            value={values.nomineeName}
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                        />
                                                        {errors.nomineeName && touched.nomineeName ? (
                                                            <span className="errors-msg">
                                                                {errors.nomineeName}
                                                            </span>
                                                        ) : null}
                                                        <span className="floating-label">Nominee Name</span>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="user-input-wrp proposal-user-input">
                                                        <MaskedInput
                                                            mask={[
                                                                /[1-9]/,
                                                                /[0-9]/
                                                            ]}
                                                            guide={false}
                                                            required
                                                            showMask={false}
                                                            placeholder=""
                                                            name="nomineeAge"
                                                            value={values.nomineeAge}
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            className="inputText"
                                                        />
                                                        {errors.nomineeAge && touched.nomineeAge ? (
                                                            <span className="errors-msg">
                                                                {errors.nomineeAge}
                                                            </span>
                                                        ) : null}
                                                        <span className="floating-label">Nominee Age (in years)</span>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="user-input-wrp">
                                                        <span className="DropDown_label">Nominee Relation</span>
                                                        <FilterData
                                                            ArrayList={NomineeRelation}
                                                            FilterKey={"CODE"}
                                                            onSelect={(data) => { setFieldValue('nomineeRelation', data.CODE); }}
                                                            DefaultTitle={initialValues.nomineeRelation ? NomineeRelation.find(option => option.CODE === initialValues.nomineeRelation)?.Name : "Select Nominee Relation"}
                                                            ListNameKey={"Name"}
                                                            className="filter_dropdwon"
                                                            formIkId="nomineeRelation"
                                                            formIkError={errors}
                                                            formIkToched={touched}
                                                            formIkBlurHandler={handleBlur}
                                                            ref={nomineeRef}
                                                        />
                                                        {/*{errors.nomineeRelation && touched.nomineeRelation && <span className="errors-msg">{errors.nomineeRelation}</span>}*/}
                                                    </div>
                                                </div>
                                            </div>

                                            <button
                                                type="button"
                                                className="FormGetLife FormGetTouch"
                                                onClick={handleSubmit}
                                                disabled={!isValid || isSubmitting}
                                            >
                                                {submitBtn }
                                                <i className="fa fa-chevron-right continue-frwd mx-1"></i>
                                            </button>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="LifeProSideCard life_side_card2">
                                        <div className="LifeProSideCard1">
                                            <div className="insurer_logo" >
                                                <img src={showDetails?.LogoUrl} className="PerpoRHdfcLogo" />
                                            </div>
                                            <p className="LifeImgHead">
                                                <strong>{showDetails?.PlanName}</strong>
                                            </p>
                                        </div>
                                        <div className="LifeProEnquiryCard2">
                                            <p className="Cust_Enquiry_Smc">Enquiry#</p>
                                            <CopyToClipboard text={showDetails?.EnquiryNo} onCopy={handleCopy}>
                                                <span className="Cust_Enquiry_Smc">
                                                    {showDetails?.EnquiryNo}
                                                    <i className="far fa-copy ms-1"></i>
                                                </span>
                                            </CopyToClipboard>
                                            {copyText && <div className="copied_Box">Copied!</div>}
                                        </div>
                                        <div className="LifeProSideCard1">
                                            <div>
                                                <p className="mb-0 ProposalDetail_CUST">Premium</p>
                                                <p className="mb-0 ProposalDetail_CUST">+ GST (18%)</p>
                                            </div>
                                            <div>
                                                <p className="mb-0 Life_Cust_premium">
                                                    ₹{CommaSeprator(showDetails?.NetPremium)}
                                                </p>
                                                <p className="mb-0 Life_Cust_premium">
                                                    ₹{CommaSeprator(showDetails?.GST)}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="LifeProSideCard3">
                                            <span className="Cust-total-Amt mb-2">
                                                Total Premium ({payFreq})
                                            </span>
                                            <span className="Cust-total-Amt mb-2">
                                                <strong>
                                                    ₹{CommaSeprator(showDetails?.TotalPremium)}
                                                </strong>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default SmcLifeProposal;
